import { render, staticRenderFns } from "./pc_approveEdit.vue?vue&type=template&id=2f2ec715&"
import script from "./pc_approveEdit.vue?vue&type=script&lang=js&"
export * from "./pc_approveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\dev_ali\\aramark-group\\aramark.bpm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2ec715')) {
      api.createRecord('2f2ec715', component.options)
    } else {
      api.reload('2f2ec715', component.options)
    }
    module.hot.accept("./pc_approveEdit.vue?vue&type=template&id=2f2ec715&", function () {
      api.rerender('2f2ec715', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPM/pc_approveEdit.vue"
export default component.exports